"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeneficiaryValidationResultCode = exports.AccountTypeCode = exports.DepositStatusReasonCode = exports.ProlongationCode = exports.AutomatedProlongCode = exports.AccounContractConfirmationTypeCode = exports.DepositSigningMethod = exports.DepositStatusCode = exports.ExternalAccountValidationStatus = exports.UsageRank = exports.PromiseToPayPaymentStatusCode = exports.PromiseToPayTypeCode = exports.PromiseToPayStatusCode = exports.AccountStatementContentType = exports.AccountProductGroup = exports.AccountStatementBusinessLine = exports.AccountStatementAccountStatusCode = exports.AccountSystemPropertyValyeTypeCode = exports.AccountSystemPropertyCode = exports.ReferenceTypeCode = exports.LookupCode = exports.AccountStatusCode = exports.AgreementTypeCode = exports.PrintoutTypeCode = exports.DepositInterestAlgorithmCode = exports.DepositPeriodCode = exports.InterestPaymentFrequencyCode = exports.DepositCheckType = void 0;
var DepositCheckType;
(function (DepositCheckType) {
    DepositCheckType["Info"] = "INFO";
    DepositCheckType["Transactional"] = "TRANSACTIONAL";
})(DepositCheckType || (exports.DepositCheckType = DepositCheckType = {}));
var InterestPaymentFrequencyCode;
(function (InterestPaymentFrequencyCode) {
    InterestPaymentFrequencyCode["Month"] = "MONTH";
    InterestPaymentFrequencyCode["Year"] = "YEAR";
    InterestPaymentFrequencyCode["End"] = "END";
})(InterestPaymentFrequencyCode || (exports.InterestPaymentFrequencyCode = InterestPaymentFrequencyCode = {}));
var DepositPeriodCode;
(function (DepositPeriodCode) {
    DepositPeriodCode["Months"] = "MONTHS";
    DepositPeriodCode["Days"] = "DAYS";
    DepositPeriodCode["Years"] = "YEARS";
})(DepositPeriodCode || (exports.DepositPeriodCode = DepositPeriodCode = {}));
var DepositInterestAlgorithmCode;
(function (DepositInterestAlgorithmCode) {
    DepositInterestAlgorithmCode["A365"] = "A/365";
})(DepositInterestAlgorithmCode || (exports.DepositInterestAlgorithmCode = DepositInterestAlgorithmCode = {}));
var PrintoutTypeCode;
(function (PrintoutTypeCode) {
    PrintoutTypeCode["Agreement"] = "AGREEMENT";
    PrintoutTypeCode["DepositPaymentSchedule"] = "DEPOSIT_PAYMENT_SCHEDULE";
    PrintoutTypeCode["Notification"] = "NOTIFICATION";
    PrintoutTypeCode["AgreementSigned"] = "AGREEMENT_SIGNED";
    PrintoutTypeCode["NotificationSigned"] = "NOTIFICATION_SIGNED";
    PrintoutTypeCode["PromiseToPay"] = "PROMISE_TO_PAY";
    PrintoutTypeCode["PromiseToPayOffice"] = "PROMISE_TO_PAY_OFFICE";
    PrintoutTypeCode["PromiseToPayTerminated"] = "PROMISE_TO_PAY_TERMINATED";
    PrintoutTypeCode["PromiseToPayOfficeTerminated"] = "PROMISE_TO_PAY_OFFICE_TERMINATED";
    PrintoutTypeCode["Application"] = "APPLICATION";
    PrintoutTypeCode["DepoInterestCertificate"] = "DEPO_INTEREST_CERTIFICATE";
    PrintoutTypeCode["DepoBalanceCertificate"] = "DEPO_BALANCE_CERTIFICATE";
    PrintoutTypeCode["CustomerAccountStatement"] = "CUSTOMER_ACCOUNT_STATEMENT";
    PrintoutTypeCode["CustomerCreditCardAccountStatement"] = "CUSTOMER_CREDIT_CARD_ACCOUNT_STATEMENT";
    PrintoutTypeCode["CustomerDepositAccountStatement"] = "CUSTOMER_DEPOSIT_ACCOUNT_STATEMENT";
    PrintoutTypeCode["ContractPay"] = "CONTRACT_PAY";
    PrintoutTypeCode["ContractMid"] = "CONTRACT_MID";
    PrintoutTypeCode["ContractOffice"] = "CONTRACT_OFFICE";
    PrintoutTypeCode["InsuranceNotification"] = "INSURANCE_NOTIFICATION";
    PrintoutTypeCode["CustomerAccountStatementOfFees"] = "CUSTOMER_ACCOUNT_STATEMENT_OF_FEES";
    PrintoutTypeCode["CustomerAccountStatementOfFeesCC"] = "CUSTOMER_ACCOUNT_STATEMENT_OF_FEES_CC";
})(PrintoutTypeCode || (exports.PrintoutTypeCode = PrintoutTypeCode = {}));
var AgreementTypeCode;
(function (AgreementTypeCode) {
    AgreementTypeCode["Current"] = "C";
    AgreementTypeCode["Deposit"] = "D";
    AgreementTypeCode["SavingsDeposit"] = "DC";
    AgreementTypeCode["Leasing"] = "L";
})(AgreementTypeCode || (exports.AgreementTypeCode = AgreementTypeCode = {}));
var AccountStatusCode;
(function (AccountStatusCode) {
    AccountStatusCode["Open"] = "OPEN";
    AccountStatusCode["Active"] = "ACTIVE";
    AccountStatusCode["Blocked"] = "BLOCKED";
    AccountStatusCode["Closed"] = "CLOSED";
    AccountStatusCode["Frozen"] = "FROZEN";
    AccountStatusCode["Arrested"] = "ARRESTED";
})(AccountStatusCode || (exports.AccountStatusCode = AccountStatusCode = {}));
var LookupCode;
(function (LookupCode) {
    LookupCode["MoneyOrigin"] = "MONEY_ORIGIN";
    LookupCode["MoneyOriginLegal"] = "MONEY_ORIGIN_LEGAL";
    LookupCode["MoneyOriginPrivate"] = "MONEY_ORIGIN_PRIVATE";
    LookupCode["DepoIntrFreq"] = "DEPO_INTR_FREQ";
    LookupCode["Prolong"] = "PROLONG";
    LookupCode["StatusAccount"] = "STATUS_ACCOUNT";
    LookupCode["StatusDepoApplication"] = "STATUS_DEPO_APPLICATION";
    LookupCode["StatusDepoContract"] = "STATUS_DEPO_CONTRACT";
    LookupCode["SignChannel"] = "SIGN_CHANNEL";
    LookupCode["BlockReason"] = "BLOCK_REASON";
    LookupCode["CloseReason"] = "CLOSE_REASON";
    LookupCode["ContractStatusReasonCode"] = "CONTRACT_STATUS_REASON_CODE";
    LookupCode["ContractPrintoutType"] = "CONTRACT_PRINTOUT_TYPE";
    LookupCode["DepositPeriodCode"] = "DEPOSIT_PERIOD_CODE";
    LookupCode["SourceNameMatch"] = "SOURCE_NAME_MATCH";
    LookupCode["TerminationType"] = "TERMINATION_TYPE";
    LookupCode["AccruedInterestDebit"] = "ACCRUED_INTEREST_DEBIT";
    LookupCode["PaidOutInterestDebit"] = "PAID_OUT_INTEREST_DEBIT";
    LookupCode["ContractCancellationReason"] = "CONTRACT_CANCELLATION_REASON";
    LookupCode["TransactionDirection"] = "TRANSACTION_DIRECTION";
    LookupCode["AgreementTypeCode"] = "AGREEMENT_TYPE_CODE";
    LookupCode["DepositComponentType"] = "DEPOSIT_COMPONENT_TYPE";
    LookupCode["ContractRejectionReason"] = "CONTRACT_REJECTION_REASON";
    LookupCode["AccountGeneralTermsName"] = "ACCOUNT_GENERAL_TERMS_NAME";
    LookupCode["AccountTypeCode"] = "ACCOUNT_TYPE_CODE";
    LookupCode["DepositSearchResult"] = "DEPOSIT_SEARCH_RESULT";
    LookupCode["PromiseToPayStatusCode"] = "PROMISE_TO_PAY_STATUS_CODE";
    LookupCode["PromiseToPayPaymentStatusCode"] = "PROMISE_TO_PAY_PAYMENT_STATUS_CODE";
    LookupCode["PromiseToPayType"] = "PROMISE_TO_PAY_TYPE";
    LookupCode["PromiseToPayTypeLeasing"] = "PROMISE_TO_PAY_TYPE_LEASING";
    LookupCode["PromiseToPayBuyoutBy"] = "PROMISE_TO_PAY_BUYOUT_BY";
    LookupCode["PromiseToPayDocumentType"] = "PROMISE_TO_PAY_DOCUMENT_TYPE";
    LookupCode["PaymentStatusCode"] = "PAYMENT_STATUS_CODE";
    LookupCode["DepositDataChangeCode"] = "DEPOSIT_DATA_CHANGE_CODE";
    LookupCode["NotificationTemplateTitle"] = "NOTIFICATION_TEMPLATE_TITLE";
    LookupCode["PromiseToPayPaymentNumber"] = "PROMISE_TO_PAY_PAYMENT_NUMBER";
    LookupCode["PromiseToPaySearchType"] = "PROMISE_TO_PAY_SEARCH_TYPE";
    LookupCode["AutomatedNoticeStatusCode"] = "AUTOMATED_NOTICE_STATUS_CODE";
    LookupCode["AutomatedNoticeTypeCode"] = "AUTOMATED_NOTICE_TYPE_CODE";
    LookupCode["AutomatedNoticeSubjectTypeCode"] = "AUTOMATED_NOTICE_SUBJECT_TYPE_CODE";
    LookupCode["PaymentTypeCode"] = "PAYMENT_TYPE_CODE";
    LookupCode["PositiveBalanceFullfillmentPromiseToPayStatusCode"] = "POSITIVE_BALANCE_FULLFILLMENT_PROMISE_TO_PAY_STATUS_CODE";
    LookupCode["PaymentStatusCodeUiSepaOut"] = "PAYMENT_STATUS_CODE_UI_SEPA_OUT";
    LookupCode["PaymentStatusCodeUiIn"] = "PAYMENT_STATUS_CODE_UI_IN";
    LookupCode["DepositSigningMethod"] = "DEPOSIT_SIGNING_METHOD";
    LookupCode["BankRepresentativeName"] = "BANK_REPRESENTATIVE_NAME";
    LookupCode["BankRepresentativePosition"] = "BANK_REPRESENTATIVE_POSITION";
    LookupCode["CurrencyCode"] = "CURRENCY_CODE";
    LookupCode["ReservationDealName"] = "RESERVATION_DEAL_NAME";
    LookupCode["PaymentDescription"] = "PAYMENT_DESCRIPTION";
    LookupCode["ConfirmationCode"] = "CONFIRMATION_CODE";
    LookupCode["DepositPeriodCodeSingular"] = "DEPOSIT_PERIOD_CODE_SINGULAR";
    LookupCode["DepositAccount"] = "DEPOSIT_ACCOUNT";
    LookupCode["CustomerSignatureApprovalText"] = "CUSTOMER_SIGNATURE_APPROVAL_TEXT";
    LookupCode["OtherInfoText"] = "OTHER_INFO_TEXT";
    LookupCode["OtherInfoTextProlong"] = "OTHER_INFO_TEXT_PROLONG";
    LookupCode["FieldNameOtherInfo"] = "FIELD_NAME_OTHER_INFO";
    LookupCode["FieldNameBankData"] = "FIELD_NAME_BANK_DATA";
    LookupCode["FieldNameCustomerData"] = "FIELD_NAME_CUSTOMER_DATA";
    LookupCode["FieldNameRepresentativeData"] = "FIELD_NAME_REPRESENTATIVE_DATA";
    LookupCode["FieldNameAmount"] = "FIELD_NAME_AMOUNT";
    LookupCode["FieldNameInterest"] = "FIELD_NAME_INTEREST";
    LookupCode["FieldNamePeriod"] = "FIELD_NAME_PERIOD";
    LookupCode["FieldNamePeriodText"] = "FIELD_NAME_PERIOD_TEXT";
    LookupCode["FieldNamePaymentInfo"] = "FIELD_NAME_PAYMENT_INFO";
    LookupCode["FieldNameBic"] = "FIELD_NAME_BIC";
    LookupCode["FieldNameBeneficiaryAccount"] = "FIELD_NAME_BENEFICIARY_ACCOUNT";
    LookupCode["FieldNameBeneficiaryName"] = "FIELD_NAME_BENEFICIARY_NAME";
    LookupCode["FieldNameRefNumber"] = "FIELD_NAME_REF_NUMBER";
    LookupCode["FieldNameContractNumber"] = "FIELD_NAME_CONTRACT_NUMBER";
    LookupCode["FieldNameIntrFreq"] = "FIELD_NAME_INTR_FREQ";
    LookupCode["FieldNameProlong"] = "FIELD_NAME_PROLONG";
    LookupCode["FieldNameSpecialConditions"] = "FIELD_NAME_SPECIAL_CONDITIONS";
    LookupCode["FieldNameBankName"] = "FIELD_NAME_BANK_NAME";
    LookupCode["FieldNameBankRegNo"] = "FIELD_NAME_BANK_REG_NO";
    LookupCode["FieldNameBankAddress"] = "FIELD_NAME_BANK_ADDRESS";
    LookupCode["FieldNameBankPhone"] = "FIELD_NAME_BANK_PHONE";
    LookupCode["FieldNameBankEmail"] = "FIELD_NAME_BANK_EMAIL";
    LookupCode["FieldNameCustomerName"] = "FIELD_NAME_CUSTOMER_NAME";
    LookupCode["FieldNameCustomerPersonalCode"] = "FIELD_NAME_CUSTOMER_PERSONAL_CODE";
    LookupCode["FieldNameCustomerAddress"] = "FIELD_NAME_CUSTOMER_ADDRESS";
    LookupCode["FieldNameCustomerPhone"] = "FIELD_NAME_CUSTOMER_PHONE";
    LookupCode["FieldNameCustomerEmail"] = "FIELD_NAME_CUSTOMER_EMAIL";
    LookupCode["FieldNameCustomerCitizen"] = "FIELD_NAME_CUSTOMER_CITIZEN";
    LookupCode["FieldNameCustomerBirthCounty"] = "FIELD_NAME_CUSTOMER_BIRTH_COUNTY";
    LookupCode["FieldNameCustomerTaxResidencyCountry"] = "FIELD_NAME_CUSTOMER_TAX_RESIDENCY_COUNTRY";
    LookupCode["FieldNameCustomerBankAccount"] = "FIELD_NAME_CUSTOMER_BANK_ACCOUNT";
    LookupCode["FieldNameBankSignature"] = "FIELD_NAME_BANK_SIGNATURE";
    LookupCode["FieldNameCustomerSignature"] = "FIELD_NAME_CUSTOMER_SIGNATURE";
    LookupCode["FieldNameCustomerBirthDay"] = "FIELD_NAME_CUSTOMER_BIRTH_DAY";
    LookupCode["FieldNameGeneralData"] = "FIELD_NAME_GENERAL_DATA";
    LookupCode["FieldNameRepresentativeSignature"] = "FIELD_NAME_REPRESENTATIVE_SIGNATURE";
    LookupCode["FieldNameCustomerRegistrationNumber"] = "FIELD_NAME_CUSTOMER_REGISTRATION_NUMBER";
    LookupCode["RepresentativeSignatureApprovalText1"] = "REPRESENTATIVE_SIGNATURE_APPROVAL_TEXT_1";
    LookupCode["RepresentativeSignatureApprovalText2"] = "REPRESENTATIVE_SIGNATURE_APPROVAL_TEXT_2";
    LookupCode["FieldNameRegistrationDate"] = "FIELD_NAME_REGISTRATION_DATE";
    LookupCode["OtherInfoTextProlong1"] = "OTHER_INFO_TEXT_PROLONG_1";
    LookupCode["FieldNameRepresentativeName"] = "FIELD_NAME_REPRESENTATIVE_NAME";
    LookupCode["GuaranteeSheetCb"] = "GUARANTEE_SHEET_CB";
    LookupCode["FieldData1"] = "FIELD_DATA_1";
    LookupCode["FieldData2"] = "FIELD_DATA_2";
    LookupCode["FieldData3"] = "FIELD_DATA_3";
    LookupCode["FieldData4"] = "FIELD_DATA_4";
    LookupCode["FieldData5"] = "FIELD_DATA_5";
    LookupCode["FieldData6"] = "FIELD_DATA_6";
    LookupCode["FieldData71"] = "FIELD_DATA_7_1";
    LookupCode["FieldData72"] = "FIELD_DATA_7_2";
    LookupCode["FieldData73"] = "FIELD_DATA_7_3";
    LookupCode["FieldData8"] = "FIELD_DATA_8";
    LookupCode["FieldName1"] = "FIELD_NAME_1";
    LookupCode["FieldName2"] = "FIELD_NAME_2";
    LookupCode["FieldName3"] = "FIELD_NAME_3";
    LookupCode["FieldName4"] = "FIELD_NAME_4";
    LookupCode["FieldName5"] = "FIELD_NAME_5";
    LookupCode["FieldName6"] = "FIELD_NAME_6";
    LookupCode["FieldName7"] = "FIELD_NAME_7";
    LookupCode["FieldName8"] = "FIELD_NAME_8";
    LookupCode["FieldName9"] = "FIELD_NAME_9";
    LookupCode["FieldName10"] = "FIELD_NAME_10";
    LookupCode["FieldNameTitle"] = "FIELD_NAME_TITLE";
    LookupCode["SheetTitle"] = "SHEET_TITLE";
    LookupCode["BankEmail"] = "BANK_EMAIL";
    LookupCode["BankPhone"] = "BANK_PHONE";
    LookupCode["BankWebsite"] = "BANK_WEBSITE";
    LookupCode["FieldNameCustomerVatNumber"] = "FIELD_NAME_CUSTOMER_VAT_NUMBER";
    LookupCode["NotificationTemplateSubTitle"] = "NOTIFICATION_TEMPLATE_SUB_TITLE";
    LookupCode["FieldNameCustomerBankAccountPrevious"] = "FIELD_NAME_CUSTOMER_BANK_ACCOUNT_PREVIOUS";
    LookupCode["FieldNameCustomerBankAccountOwnerPrevious"] = "FIELD_NAME_CUSTOMER_BANK_ACCOUNT_OWNER_PREVIOUS";
    LookupCode["FieldNameCustomerBankAccountNew"] = "FIELD_NAME_CUSTOMER_BANK_ACCOUNT_NEW";
    LookupCode["FieldNameCustomerBankAccountOwnerNew"] = "FIELD_NAME_CUSTOMER_BANK_ACCOUNT_OWNER_NEW";
    LookupCode["FieldNameChangeProlong"] = "FIELD_NAME_CHANGE_PROLONG";
    LookupCode["FieldNameInterestText"] = "FIELD_NAME_INTEREST_TEXT";
    LookupCode["MoneyOriginRiskReasonCode"] = "MONEY_ORIGIN_RISK_REASON_CODE";
    LookupCode["Pep"] = "PEP";
    LookupCode["ApplicationTemplateTitle"] = "APPLICATION_TEMPLATE_TITLE";
    LookupCode["ApplicationPrintoutLocation"] = "APPLICATION_PRINTOUT_LOCATION";
    LookupCode["Activity"] = "ACTIVITY";
    LookupCode["GuaranteeSheetLv"] = "GUARANTEE_SHEET_LV";
    LookupCode["ContractPrintoutLocation"] = "CONTRACT_PRINTOUT_LOCATION";
    LookupCode["BankNameAdditional"] = "BANK_NAME_ADDITIONAL";
    LookupCode["SmsConfigurationTag"] = "SMS_CONFIGURATION_TAG";
    LookupCode["ExternalAccount"] = "EXTERNAL_ACCOUNT";
    LookupCode["ContractTypeForPayment"] = "CONTRACT_TYPE_FOR_PAYMENT";
    LookupCode["Title"] = "TITLE";
    LookupCode["FieldNamePaymentDate"] = "FIELD_NAME_PAYMENT_DATE";
    LookupCode["FieldNameTotalAmount"] = "FIELD_NAME_TOTAL_AMOUNT";
    LookupCode["ConfirmationText"] = "CONFIRMATION_TEXT";
    LookupCode["FieldNameBankRegistrationNumber"] = "FIELD_NAME_BANK_REGISTRATION_NUMBER";
    LookupCode["FieldNameBankVatNumber"] = "FIELD_NAME_BANK_VAT_NUMBER";
    LookupCode["FieldNameStartDate"] = "FIELD_NAME_START_DATE";
    LookupCode["FieldNameEndDate"] = "FIELD_NAME_END_DATE";
    LookupCode["DepoTaxCertificateLanguageCode"] = "DEPO_TAX_CERTIFICATE_LANGUAGE_CODE";
    LookupCode["DepoTaxCertificateTypeCode"] = "DEPO_TAX_CERTIFICATE_TYPE_CODE";
    LookupCode["DepoSearchChannelCode"] = "DEPO_SEARCH_CHANNEL_CODE";
    LookupCode["FieldNameTableInfo"] = "FIELD_NAME_TABLE_INFO";
    LookupCode["SarActionCode"] = "SAR_ACTION_CODE";
    LookupCode["SarActionReasonCode"] = "SAR_ACTION_REASON_CODE";
    LookupCode["SarEventStatusCode"] = "SAR_EVENT_STATUS_CODE";
    LookupCode["SarCounterpartyTypeCode"] = "SAR_COUNTERPARTY_TYPE_CODE";
    LookupCode["SarConnectionUsageRank"] = "SAR_CONNECTION_USAGE_RANK";
    LookupCode["SarConnectionStatusCode"] = "SAR_CONNECTION_STATUS_CODE";
    LookupCode["FieldNameCurrency"] = "FIELD_NAME_CURRENCY";
    LookupCode["FieldNameInterestPaymentPeriod"] = "FIELD_NAME_INTEREST_PAYMENT_PERIOD";
    LookupCode["SarEventTypeCode"] = "SAR_EVENT_TYPE_CODE";
    LookupCode["SaveDepoTaxCertText"] = "SAVE_DEPO_TAX_CERT_TEXT";
    LookupCode["AccountStatementLanguageCode"] = "ACCOUNT_STATEMENT_LANGUAGE_CODE";
    LookupCode["SarCounterpartySubtypeCode"] = "SAR_COUNTERPARTY_SUBTYPE_CODE";
    LookupCode["FieldGuaranteedDateText"] = "FIELD_GUARANTEED_DATE_TEXT";
    LookupCode["TransactionTypeCode"] = "TRANSACTION_TYPE_CODE";
    LookupCode["AccountStatementFieldName"] = "ACCOUNT_STATEMENT_FIELD_NAME";
})(LookupCode || (exports.LookupCode = LookupCode = {}));
var ReferenceTypeCode;
(function (ReferenceTypeCode) {
    ReferenceTypeCode["Customer"] = "CUSTOMER";
    ReferenceTypeCode["Contract"] = "CONTRACT";
    ReferenceTypeCode["Account"] = "ACCOUNT";
})(ReferenceTypeCode || (exports.ReferenceTypeCode = ReferenceTypeCode = {}));
var AccountSystemPropertyCode;
(function (AccountSystemPropertyCode) {
    AccountSystemPropertyCode["TransactionAllowed"] = "TRANSACTION_ALLOWED";
    AccountSystemPropertyCode["ClearingCutOff"] = "CLEARING_CUT_OFF";
    AccountSystemPropertyCode["OurBic"] = "OUR_BIC";
    AccountSystemPropertyCode["BaseCurrency"] = "BASE_CURRENCY";
    AccountSystemPropertyCode["ContractAccount"] = "CONTRACT_ACCOUNT";
    AccountSystemPropertyCode["OurRegCode"] = "OUR_REG_CODE";
    AccountSystemPropertyCode["GlobalProcessingAllowed"] = "GLOBAL_PROCESSING_ALLOWED";
    AccountSystemPropertyCode["PromiseToPayDelta"] = "PROMISE_TO_PAY_DELTA";
    AccountSystemPropertyCode["PromiseToPayDeltaFullRepayment"] = "PROMISE_TO_PAY_DELTA_FULL_REPAYMENT";
    AccountSystemPropertyCode["SepaOutPaymentAcceptanceLimit"] = "SEPA_OUT_PAYMENT_ACCEPTANCE_LIMIT";
    AccountSystemPropertyCode["IntrabankPaymentAcceptanceLimit"] = "INTRABANK_PAYMENT_ACCEPTANCE_LIMIT";
    AccountSystemPropertyCode["EinvoiceCollectionAccount"] = "EINVOICE_COLLECTION_ACCOUNT";
    AccountSystemPropertyCode["DefaultServiceAccountType"] = "DEFAULT_SERVICE_ACCOUNT_TYPE";
    AccountSystemPropertyCode["PromiseToPaySmsLimit"] = "PROMISE_TO_PAY_SMS_LIMIT";
    AccountSystemPropertyCode["AccountFormat"] = "ACCOUNT_FORMAT";
    AccountSystemPropertyCode["DefaultReferenceNumberType"] = "DEFAULT_REFERENCE_NUMBER_TYPE";
    AccountSystemPropertyCode["OutgoingPaymentAccountCheckMethod"] = "OUTGOING_PAYMENT_ACCOUNT_CHECK_METHOD";
    AccountSystemPropertyCode["ClearingNumberUsed"] = "CLEARING_NUMBER_USED";
    AccountSystemPropertyCode["BankGiroNumber"] = "BANK_GIRO_NUMBER";
    AccountSystemPropertyCode["IncomingPaymentBeneficiaryCheckMethod"] = "INCOMING_PAYMENT_BENEFICIARY_CHECK_METHOD";
    AccountSystemPropertyCode["PromiseToPayIncomingsCheckDays"] = "PROMISE_TO_PAY_INCOMINGS_CHECK_DAYS";
    AccountSystemPropertyCode["PromiseToPayIncomingsTrackDate"] = "PROMISE_TO_PAY_INCOMINGS_TRACK_DATE";
    AccountSystemPropertyCode["DepoCustomerResidency"] = "DEPO_CUSTOMER_RESIDENCY";
    AccountSystemPropertyCode["DepoContractAccount"] = "DEPO_CONTRACT_ACCOUNT";
    AccountSystemPropertyCode["DepoIdentDocument"] = "DEPO_IDENT_DOCUMENT";
    AccountSystemPropertyCode["DepoContractAddress"] = "DEPO_CONTRACT_ADDRESS";
    AccountSystemPropertyCode["DepoInvestmentAccountCheck"] = "DEPO_INVESTMENT_ACCOUNT_CHECK";
    AccountSystemPropertyCode["PromiseToPayWithFeeIncomingsCheckDays"] = "PROMISE_TO_PAY_WITH_FEE_INCOMINGS_CHECK_DAYS";
    AccountSystemPropertyCode["DepoApplication"] = "DEPO_APPLICATION";
    AccountSystemPropertyCode["SarPaymentAmountPeriod"] = "SAR_PAYMENT_AMOUNT_PERIOD";
    AccountSystemPropertyCode["SmsConfigurationTagReferenceNumber"] = "SMS_CONFIGURATION_TAG_REFERENCE_NUMBER";
    AccountSystemPropertyCode["SmsConfigurationTagPreviousDate"] = "SMS_CONFIGURATION_TAG_PREVIOUS_DATE";
    AccountSystemPropertyCode["SmsConfigurationTagIban"] = "SMS_CONFIGURATION_TAG_IBAN";
    AccountSystemPropertyCode["SmsConfigurationTagDueDate"] = "SMS_CONFIGURATION_TAG_DUE_DATE";
    AccountSystemPropertyCode["SmsConfigurationTagCurrencyCode"] = "SMS_CONFIGURATION_TAG_CURRENCY_CODE";
    AccountSystemPropertyCode["SmsConfigurationTagContractNumber"] = "SMS_CONFIGURATION_TAG_CONTRACT_NUMBER";
    AccountSystemPropertyCode["SmsConfigurationTagAmount"] = "SMS_CONFIGURATION_TAG_AMOUNT";
    AccountSystemPropertyCode["PromiseToPayNotActiveContractsCheckDays"] = "PROMISE_TO_PAY_NOT_ACTIVE_CONTRACTS_CHECK_DAYS";
    AccountSystemPropertyCode["PromiseToPayPenaltyRestoreDate"] = "PROMISE_TO_PAY_PENALTY_RESTORE_DATE";
    AccountSystemPropertyCode["PromiseToPayContractRequired"] = "PROMISE_TO_PAY_CONTRACT_REQUIRED";
    AccountSystemPropertyCode["DepoContractRegenerationDate"] = "DEPO_CONTRACT_REGENERATION_DATE";
    AccountSystemPropertyCode["DepoPopulationRegisterQuery"] = "DEPO_POPULATION_REGISTER_QUERY";
    AccountSystemPropertyCode["DepoTaxCertificate"] = "DEPO_TAX_CERTIFICATE";
    AccountSystemPropertyCode["DefaultServiceAccountTypeLease"] = "DEFAULT_SERVICE_ACCOUNT_TYPE_LEASE";
    AccountSystemPropertyCode["RevolvingLoanAccountBlockingDaysInDebt"] = "REVOLVING_LOAN_ACCOUNT_BLOCKING_DAYS_IN_DEBT";
    AccountSystemPropertyCode["DepositLastSiginigDateMinCheckDays"] = "DEPOSIT_LAST_SIGINING_DATE_MIN_CHECK_DAYS";
    AccountSystemPropertyCode["DepositLastSiginigDateMaxCheckDays"] = "DEPOSIT_LAST_SIGINING_DATE_MAX_CHECK_DAYS";
    AccountSystemPropertyCode["DepositLastActivationDateMinCheckDays"] = "DEPOSIT_LAST_ACTIVATION_DATE_MIN_CHECK_DAYS";
    AccountSystemPropertyCode["DepositLastActivationDateMaxCheckDays"] = "DEPOSIT_LAST_ACTIVATION_DATE_MAX_CHECK_DAYS";
    AccountSystemPropertyCode["CustomerAccountStatementSupported"] = "CUSTOMER_ACCOUNT_STATEMENT_SUPPORTED";
})(AccountSystemPropertyCode || (exports.AccountSystemPropertyCode = AccountSystemPropertyCode = {}));
var AccountSystemPropertyValyeTypeCode;
(function (AccountSystemPropertyValyeTypeCode) {
    AccountSystemPropertyValyeTypeCode["Boolean"] = "BOOLEAN";
    AccountSystemPropertyValyeTypeCode["String"] = "STRING";
    AccountSystemPropertyValyeTypeCode["Number"] = "NUMBER";
    AccountSystemPropertyValyeTypeCode["Date"] = "DATE";
})(AccountSystemPropertyValyeTypeCode || (exports.AccountSystemPropertyValyeTypeCode = AccountSystemPropertyValyeTypeCode = {}));
var AccountStatementAccountStatusCode;
(function (AccountStatementAccountStatusCode) {
    AccountStatementAccountStatusCode["Active"] = "ACTIVE";
    AccountStatementAccountStatusCode["Blocked"] = "BLOCKED";
    AccountStatementAccountStatusCode["Closed"] = "CLOSED";
    AccountStatementAccountStatusCode["Frozen"] = "FROZEN";
    AccountStatementAccountStatusCode["Open"] = "OPEN";
    AccountStatementAccountStatusCode["Arrested"] = "ARRESTED";
})(AccountStatementAccountStatusCode || (exports.AccountStatementAccountStatusCode = AccountStatementAccountStatusCode = {}));
var AccountStatementBusinessLine;
(function (AccountStatementBusinessLine) {
    AccountStatementBusinessLine["Loan"] = "LOAN";
    AccountStatementBusinessLine["SavingDeposit"] = "SAVING_DEPOSIT";
    AccountStatementBusinessLine["TimeDeposit"] = "TIME_DEPOSIT";
    AccountStatementBusinessLine["Leasing"] = "LEASING";
    AccountStatementBusinessLine["CurrentAccount"] = "CURRENT_ACCOUNT";
})(AccountStatementBusinessLine || (exports.AccountStatementBusinessLine = AccountStatementBusinessLine = {}));
var AccountProductGroup;
(function (AccountProductGroup) {
    AccountProductGroup["SavingDeposit"] = "SAVING_DEPOSIT";
    AccountProductGroup["TimeDeposit"] = "TIME_DEPOSIT";
    AccountProductGroup["SmallLoan"] = "SMALL_LOAN";
    AccountProductGroup["CreditLine"] = "CREDIT_LINE";
})(AccountProductGroup || (exports.AccountProductGroup = AccountProductGroup = {}));
var AccountStatementContentType;
(function (AccountStatementContentType) {
    AccountStatementContentType["PDF"] = "application/pdf";
    AccountStatementContentType["ASICE"] = "application/vnd.etsi.asic-e+zip";
    AccountStatementContentType["CSV"] = "application/octet-stream";
    AccountStatementContentType["XLSX"] = "application/vnd.ms-excel";
})(AccountStatementContentType || (exports.AccountStatementContentType = AccountStatementContentType = {}));
var PromiseToPayStatusCode;
(function (PromiseToPayStatusCode) {
    PromiseToPayStatusCode["Active"] = "ACTIVE";
    PromiseToPayStatusCode["Completed"] = "COMPLETED";
    PromiseToPayStatusCode["Terminated"] = "TERMINATED";
    PromiseToPayStatusCode["Incomplete"] = "INCOMPLETE";
})(PromiseToPayStatusCode || (exports.PromiseToPayStatusCode = PromiseToPayStatusCode = {}));
var PromiseToPayTypeCode;
(function (PromiseToPayTypeCode) {
    PromiseToPayTypeCode["PartialRepayment"] = "PARTIAL_REPAYMENT";
    PromiseToPayTypeCode["FullRepayment"] = "FULL_REPAYMENT";
    PromiseToPayTypeCode["FullRepaymentLeasing"] = "FULL_REPAYMENT_LEASING";
})(PromiseToPayTypeCode || (exports.PromiseToPayTypeCode = PromiseToPayTypeCode = {}));
var PromiseToPayPaymentStatusCode;
(function (PromiseToPayPaymentStatusCode) {
    PromiseToPayPaymentStatusCode["Completed"] = "COMPLETED";
    PromiseToPayPaymentStatusCode["Incomplete"] = "INCOMPLETE";
    PromiseToPayPaymentStatusCode["WaitingFunds"] = "WAITING_FUNDS";
})(PromiseToPayPaymentStatusCode || (exports.PromiseToPayPaymentStatusCode = PromiseToPayPaymentStatusCode = {}));
var UsageRank;
(function (UsageRank) {
    UsageRank["First"] = "FIRST";
    UsageRank["Second"] = "SECOND";
    UsageRank["Third"] = "THIRD";
    UsageRank["Other"] = "OTHER";
})(UsageRank || (exports.UsageRank = UsageRank = {}));
var ExternalAccountValidationStatus;
(function (ExternalAccountValidationStatus) {
    ExternalAccountValidationStatus["Validated"] = "VALIDATED";
    ExternalAccountValidationStatus["InValidationProcess"] = "IN_VALIDATION_PROCESS";
    ExternalAccountValidationStatus["NotValidated"] = "NOT_VALIDATED";
})(ExternalAccountValidationStatus || (exports.ExternalAccountValidationStatus = ExternalAccountValidationStatus = {}));
var DepositStatusCode;
(function (DepositStatusCode) {
    DepositStatusCode["Forwarded"] = "FORWARDED";
    DepositStatusCode["WaitingSigning"] = "WAITING_SIGNING";
    DepositStatusCode["WaitingFunds"] = "WAITING_FUNDS";
    DepositStatusCode["Active"] = "ACTIVE";
    DepositStatusCode["Cancelled"] = "CANCELLED";
    DepositStatusCode["Proceeding"] = "PROCEEDING";
    DepositStatusCode["Rejected"] = "REJECTED";
    DepositStatusCode["Terminated"] = "TERMINATED";
    DepositStatusCode["Closed"] = "CLOSED";
})(DepositStatusCode || (exports.DepositStatusCode = DepositStatusCode = {}));
var DepositSigningMethod;
(function (DepositSigningMethod) {
    DepositSigningMethod["SmartId"] = "SMART_ID";
    DepositSigningMethod["IdCard"] = "ID_CARD";
    DepositSigningMethod["MobileId"] = "MOBILE_ID";
    DepositSigningMethod["Manual"] = "MANUAL";
    DepositSigningMethod["OtherElectronicFormat"] = "OTHER_ELECTRONIC_FORMAT";
})(DepositSigningMethod || (exports.DepositSigningMethod = DepositSigningMethod = {}));
var AccounContractConfirmationTypeCode;
(function (AccounContractConfirmationTypeCode) {
    AccounContractConfirmationTypeCode["BenefitionOwner"] = "BENEFITION_OWNER";
    AccounContractConfirmationTypeCode["BenefitionContractTerm"] = "BENEFITION_CONTRACT_TERM";
})(AccounContractConfirmationTypeCode || (exports.AccounContractConfirmationTypeCode = AccounContractConfirmationTypeCode = {}));
var AutomatedProlongCode;
(function (AutomatedProlongCode) {
    AutomatedProlongCode["Yes"] = "YES";
    AutomatedProlongCode["No"] = "NO";
})(AutomatedProlongCode || (exports.AutomatedProlongCode = AutomatedProlongCode = {}));
var ProlongationCode;
(function (ProlongationCode) {
    ProlongationCode["ChangedConditions"] = "CHANGED_CONDITIONS";
    ProlongationCode["Yes"] = "YES";
    ProlongationCode["No"] = "NO";
})(ProlongationCode || (exports.ProlongationCode = ProlongationCode = {}));
var DepositStatusReasonCode;
(function (DepositStatusReasonCode) {
    DepositStatusReasonCode["AMLAssetThresholdExceeded"] = "AML_ASSET_THRESHOLD_EXCEEDED";
    DepositStatusReasonCode["MoneyOriginMaxLimitExceeded"] = "MONEY_ORIGIN_MAX_LIMIT_EXCEEDED";
    DepositStatusReasonCode["MoneyOriginOther"] = "MONEY_ORIGIN_OTHER";
    DepositStatusReasonCode["PopulationRegisterCheck"] = "POPULATION_REGISTER_CHECK";
})(DepositStatusReasonCode || (exports.DepositStatusReasonCode = DepositStatusReasonCode = {}));
var AccountTypeCode;
(function (AccountTypeCode) {
    AccountTypeCode["CURREE01"] = "CURREE01";
    AccountTypeCode["CURREE02"] = "CURREE02";
    AccountTypeCode["CURRLT01"] = "CURRLT01";
    AccountTypeCode["CURRLT02"] = "CURRLT02";
    AccountTypeCode["CURRLV01"] = "CURRLV01";
    AccountTypeCode["CURRLV02"] = "CURRLV02";
    // Add more if needed
})(AccountTypeCode || (exports.AccountTypeCode = AccountTypeCode = {}));
var BeneficiaryValidationResultCode;
(function (BeneficiaryValidationResultCode) {
    // External IBAN, no validation needed
    BeneficiaryValidationResultCode["ExternalBeneficiary"] = "EXTERNAL_BENEFICIARY";
    // Bigbank IBAN format but account doesn't exist, perhaps user mistyped the IBAN number
    BeneficiaryValidationResultCode["BigbankIBANFormatButNonExistingAccount"] = "BIGBANK_IBAN_FORMAT_NON_EXISTING_ACCOUNT";
    // Bigbank IBAN and IBAN is found but name doesn't match the account owner name
    BeneficiaryValidationResultCode["BigbankIBANFormatButNameMismatch"] = "BIGBANK_IBAN_FORMAT_NAME_MISMATCH";
    // Bigbank IBAN and IBAN is found and name also matches the account owner
    BeneficiaryValidationResultCode["BigbankIBANFormatAndNameMatch"] = "BIGBANK_IBAN_FORMAT_NAME_MATCH";
    // Bigbank IBAN format but account type isn't for current account, no validation check.
    // ABC will return the branch name for the account
    BeneficiaryValidationResultCode["BigbankIBANFormatButNonCurrentAccount"] = "BIGBANK_IBAN_FORMAT_NON_CURR_ACCOUNT_BENEFICIARY";
})(BeneficiaryValidationResultCode || (exports.BeneficiaryValidationResultCode = BeneficiaryValidationResultCode = {}));
